export const CellId = {
  PAYMENT_NUMBER: 'paymentNumber',
  MONTHLY_PAYMENT: 'monthlyPayment',
  INTEREST: 'interest',
  PRINCIPAL: 'principal',
  MI: 'mi',
  MONTHLY_SUBSIDIZED_AMOUNT: 'monthlySubsidizedAmount',
  BALANCE: 'remainingBalance',
  TOTAL_MONTHLY_PAYMENT: 'totalMonthlyPayment',
  TOTAL_INTEREST: 'totalInterest',
  RATE: 'interestRate',
};
